import { HttpService, HttpServiceResponse } from '../shared'
import { LivedataServerData } from './livedata.types'

export class LivedataProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/livedata_api.php`
  }

  public get(): Promise<HttpServiceResponse<LivedataServerData>> {
    return this.http.post(`${this.url}`)
  }
}
